<template>
  <section>
    <nav-component
      :titulo="'Inventario'"
      :link="can('productos.registrar') ? { path: '/agregar-producto' } : null"
      :texto="'Agregar producto'"
    />
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag="router-link" to="/">Inicio</b-breadcrumb-item>
      <b-breadcrumb-item active>Inventario</b-breadcrumb-item>
    </b-breadcrumb>

    <mensaje-inicial
      :titulo="'No se han encontrado productos :('"
      :subtitulo="'Agrega productos pulsando el botón de Agregar productos'"
      v-if="!cargando && total === 0"
    />

    <template v-if="total > 0 || cargando">
      <cartas-totales :totales="cartasTotales" />

      <div class="table-toolbar">
        <div class="table-toolbar-left">
          <b-select
            v-model="porPagina"
            @input="cambiarPorPagina"
            size="is-small"
          >
            <option :value="10">10 / pág</option>
            <option :value="20">20 / pág</option>
            <option :value="50">50 / pág</option>
          </b-select>
          <span style="font-size: 0.78rem; color: var(--color-text-dim)"
            >{{ total }} productos</span
          >
        </div>
        <div class="table-toolbar-right">
          <b-button
            type="is-primary"
            size="is-small"
            icon-left="printer"
            tag="a"
            href="#/pdf/productos"
            target="_blank"
            rel="noopener noreferrer"
          >
            Imprimir
          </b-button>
        </div>
      </div>

      <b-table
        class="box"
        :data="productos"
        :paginated="true"
        :per-page="porPagina"
        :current-page="pagina"
        :total="total"
        :backend-pagination="true"
        :pagination-rounded="true"
        pagination-position="bottom"
        @page-change="onCambioPagina"
      >
        <b-table-column field="codigo" label="Código" sortable v-slot="props">{{
          props.row.codigo
        }}</b-table-column>
        <b-table-column field="nombre" label="Nombre" sortable v-slot="props">{{
          props.row.nombre
        }}</b-table-column>
        <b-table-column
          field="precioCompra"
          label="P.Compra"
          sortable
          v-slot="props"
          >${{ formatoMonto(props.row.precioCompra) }}</b-table-column
        >
        <b-table-column
          field="precioVenta"
          label="P.Venta"
          sortable
          v-slot="props"
          >${{ formatoMonto(props.row.precioVenta) }}</b-table-column
        >
        <b-table-column
          field="precioVenta2"
          label="P.Venta 2"
          sortable
          v-slot="props"
          >${{ formatoMonto(props.row.precioVenta2) }}</b-table-column
        >
        <b-table-column
          field="precioVenta3"
          label="P.Venta 3"
          sortable
          v-slot="props"
          >${{ formatoMonto(props.row.precioVenta3) }}</b-table-column
        >
        <b-table-column
          field="precioVenta4"
          label="P.Venta 4"
          sortable
          v-slot="props"
          >${{ formatoMonto(props.row.precioVenta4) }}</b-table-column
        >
        <b-table-column
          field="precioVenta5"
          label="P.Venta 5"
          sortable
          v-slot="props"
          >${{ formatoMonto(props.row.precioVenta5) }}</b-table-column
        >
        <b-table-column
          field="precioVenta6"
          label="P.Venta 6"
          sortable
          v-slot="props"
          >${{ formatoMonto(props.row.precioVenta6) }}</b-table-column
        >
        <b-table-column
          field="precioVenta7"
          label="P.Venta 7"
          sortable
          v-slot="props"
          >${{ formatoMonto(props.row.precioVenta7) }}</b-table-column
        >
        <b-table-column
          field="ganancia"
          label="Ganancia"
          sortable
          v-slot="props"
        >
          <b
            >${{
              formatoMonto(props.row.precioVenta - props.row.precioCompra)
            }}</b
          >
        </b-table-column>
        <b-table-column
          field="vendidoMayoreo"
          label="Mayoreo"
          sortable
          v-slot="props"
        >
          <b-tag type="is-danger" v-if="!props.row.vendidoMayoreo">No</b-tag>
          <span v-else
            ><b>${{ formatoMonto(props.row.precioMayoreo) }}</b> ·
            {{ props.row.cantidadMayoreo }}+</span
          >
        </b-table-column>
        <b-table-column
          field="existencia"
          label="Existencia"
          sortable
          v-slot="props"
          >{{ props.row.existencia }} {{ props.row.unidad }}</b-table-column
        >
        <b-table-column
          field="nombreProveedor"
          label="Proveedor"
          sortable
          v-slot="props"
          >{{ props.row.nombreProveedor }}</b-table-column
        >
        <b-table-column label="Acciones" v-slot="props">
          <div class="is-flex" style="gap: 4px">
            <b-button
              v-if="can('productos.agregar_existencia')"
              type="is-primary"
              size="is-small"
              icon-left="plus"
              @click="agregarExistencia(props.row)"
              >Agregar</b-button
            >
            <b-button
              v-if="can('productos.remover_existencia')"
              type="is-warning"
              size="is-small"
              icon-left="minus"
              @click="removerExistencia(props.row)"
              >Remover</b-button
            >
            <b-button
              v-if="can('productos.editar')"
              type="is-info"
              size="is-small"
              icon-left="pen"
              @click="editar(props.row.id)"
              >Editar</b-button
            >
            <b-button
              v-if="can('productos.eliminar')"
              type="is-danger"
              size="is-small"
              icon-left="delete"
              @click="eliminar(props.row.id)"
              >Eliminar</b-button
            >
          </div>
        </b-table-column>
      </b-table>
    </template>

    <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false" />
  </section>
</template>

<script>
import HttpService from "../../Servicios/HttpService";
import NavComponent from "../Extras/NavComponent";
import MensajeInicial from "../Extras/MensajeInicial";
import CartasTotales from "../Extras/CartasTotales";
import AyudanteSesion from "../../Servicios/AyudanteSesion";
import Utiles from "../../Servicios/Utiles";

export default {
  name: "ProductosComponent",
  components: { NavComponent, MensajeInicial, CartasTotales },

  data: () => ({
    productos: [],
    cargando: false,
    pagina: 1,
    porPagina: 20,
    total: 0,
    cartasTotales: [],
  }),

  mounted() {
    this.obtenerProductos();
  },

  methods: {
    formatoMonto(v) {
      return Utiles.formatoMonto(v);
    },
    onCambioPagina(p) {
      this.pagina = p;
      this.obtenerProductos();
    },
    cambiarPorPagina() {
      this.pagina = 1;
      this.obtenerProductos();
    },

    agregarExistencia(producto) {
      this.$buefy.dialog.prompt({
        message: "¿Cuántas piezas vas a agregar de " + producto.nombre + "?",
        cancelText: "Cancelar",
        confirmText: "Agregar",
        inputAttrs: {
          type: "number",
          placeholder: "Cantidad",
          step: "0.01",
          min: 0,
        },
        trapFocus: true,
        onConfirm: (value) => {
          this.cargando = true;
          const monto =
            (Number(value) * Number(producto.precioCompra) * 100) / 100;
          HttpService.registrar("productos.php", {
            accion: "agregar_existencia",
            entrada: {
              cantidad: value,
              id: producto.id,
              usuario: AyudanteSesion.usuario().id,
              monto,
            },
          }).then((ok) => {
            this.cargando = false;
            if (ok) {
              this.$buefy.toast.open(value + " unidades agregadas.");
              this.obtenerProductos();
            }
          });
        },
      });
    },

    removerExistencia(producto) {
      this.$buefy.dialog.prompt({
        message:
          "¿Cuántas " +
          producto.unidad +
          " retirar de " +
          producto.nombre +
          "?",
        cancelText: "Cancelar",
        confirmText: "Retirar",
        inputAttrs: {
          type: "number",
          placeholder: "Cantidad",
          min: 0,
          step: 0.01,
          max: producto.existencia,
        },
        trapFocus: true,
        onConfirm: (value) => {
          this.cargando = true;
          HttpService.registrar("productos.php", {
            accion: "remover_existencia",
            producto: {
              cantidad: value,
              id: producto.id,
              usuario: AyudanteSesion.usuario().id,
            },
          }).then((ok) => {
            this.cargando = false;
            if (ok) {
              this.$buefy.toast.open(value + " unidades retiradas.");
              this.obtenerProductos();
            }
          });
        },
      });
    },

    eliminar(id) {
      this.$buefy.dialog.confirm({
        title: "Eliminar producto",
        message:
          "¿Seguro que quieres <b>eliminar</b> este producto? Esta acción no se puede revertir.",
        confirmText: "Sí, eliminar",
        cancelText: "Cancelar",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.cargando = true;
          HttpService.eliminar("productos.php", {
            accion: "eliminar",
            id,
          }).then((ok) => {
            this.cargando = false;
            if (ok) {
              this.$buefy.toast.open({
                type: "is-success",
                message: "Producto eliminado.",
              });
              this.obtenerProductos();
            } else this.$buefy.toast.open("Error al eliminar");
          });
        },
      });
    },

    editar(id) {
      this.$router.push({ name: "EditarProducto", params: { id } });
    },

    obtenerProductos() {
      this.cargando = true;
      HttpService.obtenerConConsultas("productos.php", {
        accion: "obtener",
        pagina: this.pagina,
        porPagina: this.porPagina,
      }).then((resp) => {
        const lista = Array.isArray(resp)
          ? resp
          : resp.productos || resp.data || [];
        this.productos = lista;
        this.total = Array.isArray(resp)
          ? resp.length
          : resp.total || lista.length;

        const totP = Array.isArray(resp)
          ? lista.length
          : resp.totalProductos || lista.length;
        const totI = Array.isArray(resp) ? "" : resp.totalInventario || "";
        const ganI = Array.isArray(resp) ? "" : resp.gananciaInventario || "";

        this.cartasTotales = [
          {
            nombre: "Nº Productos",
            total: this.total,
            icono: "package-variant-closed",
            clase: "has-text-danger",
            showDollarSign: false,
          },
          {
            nombre: "Total productos",
            total: totP,
            icono: "chart-bar-stacked",
            clase: "has-text-primary",
            showDollarSign: false,
          },
          {
            nombre: "Total inventario",
            total: totI,
            icono: "currency-usd",
            clase: "has-text-success",
            showDollarSign: true,
          },
          {
            nombre: "Ganancia",
            total: ganI,
            icono: "currency-usd",
            clase: "has-text-info",
            showDollarSign: true,
          },
        ];
        this.cargando = false;
      });
    },
  },
};
</script>
